"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Selection = /** @class */ (function () {
    function Selection() {
        // user wants this, probably a checkbox
        this.activated = true;
        // selected flight package Code
        this.selected = '';
        // selected flight class name, eg.: 'economy'
        this.flightClass = null;
        // can the user interact with this at all?
        this.enabled = true;
    }
    return Selection;
}());
exports.Selection = Selection;
//# sourceMappingURL=selection.js.map